/** @jsx jsx */
import { jsx, Box } from 'theme-ui';

const Text = ({ text, textAlign, textStyles, textColor, textColorOverride }) => {
  return (
    <Box
      dangerouslySetInnerHTML={{ __html: text }}
      variant={`styles.${textStyles}`}
      sx={{
        textAlign,
        textRendering: 'optimizeLegibility',
        WebkitFontSmoothing: 'antialiased',
        mozOsxFontSmoothing: 'grayscale',
        fontSmoothing: 'antialiased',
        h1: { color: (textColorOverride ? textColorOverride : textColor) },
        h2: { color: (textColorOverride ? textColorOverride : textColor) },
        h3: { color: (textColorOverride ? textColorOverride : textColor) },
        h4: { color: (textColorOverride ? textColorOverride : textColor) },
        h5: { color: (textColorOverride ? textColorOverride : textColor) },
        h6: { color: (textColorOverride ? textColorOverride : textColor) },
        h7: { color: (textColorOverride ? textColorOverride : textColor) },
        p: { color: (textColorOverride ? textColorOverride : textColor) },
        li: { marginBottom: '20px' },
      }}
    />
  );
};

export default Text;
